module.exports = __webpack_public_path__ + "3c31c9c9803bca37790deb7e4adddfed.png";